// Deterministic color per channel slug. New channels auto-assign a stable
// color from the palette without requiring code changes.
const CHANNEL_PALETTE = [
  '#EF4444', // red
  '#F97316', // orange
  '#EAB308', // yellow
  '#22C55E', // green
  '#06B6D4', // cyan
  '#3B82F6', // blue
  '#A855F7', // purple
  '#EC4899', // pink
] as const

export function channelColor(slug: string | null | undefined): string {
  if (!slug) return CHANNEL_PALETTE[0]
  let hash = 0
  for (let i = 0; i < slug.length; i++) {
    hash = (hash * 31 + slug.charCodeAt(i)) | 0
  }
  const idx = Math.abs(hash) % CHANNEL_PALETTE.length
  return CHANNEL_PALETTE[idx] ?? CHANNEL_PALETTE[0]
}
